import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import TheResults from "./sections/TheResults";
import BeforeAndAfter from "./sections/BeforeAndAfter";
import QuickContactSiteInfo from "@/reusable_sections/Footer";
import PremiumPortfolioShowcase from "./sections/PremiumPortfolioShowcase";
export default function GalleryPage() {
  return <div>
      <Header />
      <TheResults />
      <PremiumPortfolioShowcase />
      <BeforeAndAfter />
      <QuickContactSiteInfo />
    </div>;
}